import React from "react";
import {
  Card,
  CardContent,
  // CardHeader,
  // CardTitle,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "components/ui";
import dayjs from "dayjs";
import { ReadMore } from "components/atoms";

function ModalReportProblem({ row }) {
  return (
    <Card className="min-w-full">
      {/* <CardHeader>
        <CardTitle>Report Problem Detail</CardTitle>
      </CardHeader> */}

      <CardContent className="grid gap-5">
        {/* Table */}
        <Table className="text-left text-sm text-muted-foreground">
          <TableBody>
            <TableRow>
              <TableCell className="py-4 min-w-28 font-normal text-gray-600">Email</TableCell>
              <TableCell className="py-4 text-foreground">
                {/* <div className="flex justify-end">{row?.email}</div> */}
                 <div className="flex justify-end break-all">
                  <ReadMore comment={row?.email} maxChar={120} />
                </div>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="py-4 min-w-28 font-normal text-gray-600">
                Category
              </TableCell>
              <TableCell className="py-4 text-foreground">
                <div className="flex justify-end">{row?.category?.name}</div>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="py-4 min-w-28 font-normal text-gray-600">
                Description
              </TableCell>
              <TableCell className="py-4 text-foreground w-[50%]">
                <div className="flex justify-end break-all">
                  <ReadMore comment={row?.description} maxChar={120} />
                </div>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="py-4 min-w-28 font-normal text-gray-600">
                Platform
              </TableCell>
              <TableCell className="py-4 text-foreground">
                <div className="flex justify-end">{row?.platform}</div>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="py-4 min-w-28 font-normal text-gray-600">
                Operating system
              </TableCell>
              <TableCell className="py-4 text-foreground">
                <div className="flex justify-end">{row?.os}</div>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="py-4 min-w-28 font-normal text-gray-600">
                Client
              </TableCell>
              <TableCell className="py-4 text-foreground">
                <div className="flex justify-end">{row?.client}</div>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="py-4 min-w-28 font-normal text-gray-600">
                Device
              </TableCell>
              <TableCell className="py-4 text-foreground">
                <div className="flex justify-end">{row?.device}</div>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="py-4 min-w-28 font-normal text-gray-600">
                Created At
              </TableCell>
              <TableCell className="py-4 text-foreground">
                <div className="flex justify-end">
                  {row?.created_at
                    ? dayjs(Number(row.created_at)).format("DD/MM/YYYY hh:mm A")
                    : "N/A"}
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        {/* Report Files Section */}
        {/* {row?.report_files?.length > 0 && (
          <div>
            <div className="text-sm font-medium mb-2">Report Files</div>

            <div className="flex flex-wrap gap-3">
              {row.report_files.map((file) => {
                const isImage = file.file_url;

                return (
                  <a
                    key={file.id}
                    href={file.file_url}
                    target="_blank"
                    rel="noreferrer"
                    className="block"
                  >
                    {isImage ? (
                      <img
                        src={file.file_url}
                        alt="report"
                        className="w-20 h-20 rounded-md object-cover border"
                      />
                    ) : (
                      <div className="w-20 h-20 flex items-center justify-center text-xs border rounded-md text-center p-1">
                        File
                      </div>
                    )}
                  </a>
                );
              })}
            </div>
          </div>
        )} */}
        {/* Report Files Section */}
        <div>
          <div className="text-sm font-medium mb-2">Report Files</div>

          {row?.report_files?.length > 0 ? (
            <div className="flex flex-wrap gap-3">
              {row.report_files.map((file) => {
                const isImage = file.file_url;

                return (
                  <a
                    key={file.id}
                    href={file.file_url}
                    // target="_blank"
                    rel="noreferrer"
                    className="block"
                  >
                    {isImage ? (
                      <img
                        src={file.file_url}
                        alt="report"
                        className="w-20 h-20 rounded-md object-cover border"
                      />
                    ) : (
                      <div className="w-20 h-20 flex items-center justify-center text-xs border rounded-md text-center p-1">
                        File
                      </div>
                    )}
                  </a>
                );
              })}
            </div>
          ) : (
            <div className="flex justify-center text-sm text-muted-foreground">
              No attachment found.
            </div>
          )}
        </div>
        {/* Report Files Section */}
        
      </CardContent>
    </Card>
  );
}

export default ModalReportProblem;
